import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { DefaultDataService } from 'src/app/services/default-data.service';
import { AuthorizeService } from '../../../api-authorization/authorize.service';
import { IUser } from '../../../api-authorization/IUserModel';
import { EventService } from 'src/app/services/event.service';
import { Employee } from 'src/app/shared/model/employee.model';
import { SessionContextService } from 'src/app/services/session-context.service';
import { EmployeeProfileComponent } from 'src/app/shared/components/employee-profile/employee-profile.component';
import { ConstantsService } from '../../services/constants.service';
import { Branch } from 'src/app/shared/model/Branch.model';
import { AppointmentBookerComponent } from 'src/app/shared/components/aptbooker/appointment-booker.component';
import { SessionContext } from 'src/app/shared/model/session-context.model';
import { environment } from 'src/environments/environment';
import * as dayjs from 'dayjs';
import { throwToolbarMixedModesError } from '@angular/material/toolbar';

@Component({
  selector: 'fuse-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})

export class FuseToolbarComponent implements OnInit, OnDestroy {

  showLoadingBar: boolean;
  horizontalNav: boolean;
  noNav: boolean;
  userLoggedIn = false;
  appName = 'AppTitle';
  customerName = "";
  isLogInAs = false;
  showBranchSelection: boolean = false;
  localModeActive:boolean=false;

  debug: boolean = !environment.production;

  HWCConnected: boolean = false;
  HWCHasBeenConnected: boolean = false;
  HWCUrl: string = "";
  HWCColor: string = "#00dd00";
  HWCHint: string = "Not connected to the ActiveSalon Hardware Controller";

  user$: Observable<IUser>;
  employee: Employee;
  branches: Branch[];
  branch: Branch;
  showNavBar: boolean;
  sessionSub: Subscription;
  defaultDataSub: Subscription;
  routerSub: Subscription;
  branchChangedSub: Subscription;
  terminalSub: Subscription;
  HWCSub: Subscription;
  HWCSub2: Subscription;
  HWCSub3: Subscription;
  userLogin$: Subscription;
  userLogOut$: Subscription;
  userUpdated$: Subscription;
  onHWCConnected$:Subscription;
  terminalName: string = "";
  licenceExpiry: Date;
  licenceExpiresWithin10Days: boolean = false;

  @ViewChild(EmployeeProfileComponent) employeeProfile: EmployeeProfileComponent;
  @ViewChild(AppointmentBookerComponent) aptBooker: AppointmentBookerComponent;

  constructor(
    private router: Router,
    private fuseConfig: FuseConfigService,
    private sidebarService: FuseSidebarService,
    private defaultData: DefaultDataService,
    private authService: AuthorizeService,
    private events: EventService,
    private session: SessionContextService,
    private constants: ConstantsService,
  ) {
    this.appName = this.defaultData.AppTitle || constants.AppTitle;
    this.employee = this.session.ctx.Employee;
    this.branch = this.defaultData.defData.GetBranchFromId(this.session.ctx.BranchId);
    this.branches = this.defaultData.defData.ActiveBranches;
    this.user$ = this.authService.getUser();  
    this.setLicenceExpiry(this.defaultData.defData.LicenceExpiry);

    this.onHWCConnected$ = this.events.onHWCConnected.subscribe((s:any)=>{
      
      if (s)
        this.localModeActive = s.localModeActive || s.LocalModeActive;
      else 
        this.localModeActive =false;
    });

    this.branchChangedSub = this.events.onBranchChanged.subscribe(b => {
      if (b) {
        this.branch = this.defaultData.defData.GetBranchFromId(b.BranchId);
      }
    });

    this.userLogin$ = this.events.onUserLogInComplete.subscribe(r => {
      this.employee = this.session.ctx.Employee;
      this.UpdateUI(session.ctx);
    });

    this.userLogOut$ = this.events.onUserLogOutComplete.subscribe(r => {
      this.employee = null;
      this.UpdateUI(session.ctx);
    });

    this.userUpdated$ = this.events.onUserUpdated.subscribe(r => {
      this.employee = this.session.ctx.Employee;
      this.UpdateUI(session.ctx);
    });

    this.sessionSub = this.events.onSessionContextChanged.subscribe(s => {
      if (s) {
        this.customerName = this.session.ctx.CustomerName; // s.CustomerName;
        this.employee = s.Employee;
        this.branch = this.defaultData.defData.GetBranchFromId(s.BranchId);
        this.HWCConnected = s.HasHWCConnected;
        if (s.HWCInfo.HWCUrl)
          this.HWCUrl = s.HWCInfo.HWCUrl;
        this.UpdateHWCUI();
        this.UpdateUI(s);
      }
    });

    this.HWCSub2 = this.events.onHWCDisconnected.subscribe(r => {
      this.HWCConnected = false;
      this.UpdateHWCUI();
    });

    this.HWCSub3 = this.events.onHWCConnected.subscribe(s => {
      this.HWCConnected = false;
      if (s) {
        this.HWCConnected = true;
        if (s.HWCUrl)
          this.HWCUrl = s.HWCUrl;
      }
      this.UpdateHWCUI();
    });

    this.HWCSub = this.events.onHWCFound.subscribe(s => {
      this.HWCConnected = false;
      if (s) {
        this.HWCConnected = true;
        if (s.HWCUrl)
          this.HWCUrl = s.HWCUrl;
      }
      this.UpdateHWCUI();
    });

    this.terminalSub = this.events.onTerminalChanged.subscribe(s => {
      if (s) {
        this.UpdateUI(session.ctx);
      }
    });

    this.defaultDataSub = this.events.onDefaultDataChanged.subscribe(d => {
      if (d) {
        this.branches = d.ActiveBranches.sort((a, b) => (a.BranchName > b.BranchName ? 1 : -1));
        this.branch = d.GetBranchFromId(this.session.ctx.BranchId);
        this.appName = d.AppTitle;
        this.customerName = d?.CustomerName;
        this.setLicenceExpiry(d?.LicenceExpiry);
      }
    });

    this.routerSub = router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.showLoadingBar = true;
        }
        if (event instanceof NavigationEnd) {
          this.showLoadingBar = false;
        }
        if (event instanceof NavigationCancel) {
          this.showLoadingBar = false;
        }
      });

    this.fuseConfig.onConfigChanged.subscribe((settings) => {
      this.horizontalNav = settings.layout.navigation === 'top';
      this.noNav = settings.layout.navigation === 'none';
    });
  }

  UpdateHWCUI() {
    if (this.HWCConnected && this.HWCUrl.length > 0) {
      this.HWCColor = "#00dd00";
      this.HWCHint = "Connected to the Active Salon Hardware Controller";
      this.HWCHasBeenConnected = true;
    }
    else {
      if (this.HWCHasBeenConnected)
        this.HWCColor = "#dd0000";
      else
        this.HWCColor = "#eeeeee";
      this.HWCHint = "Not connected to the Active Salon Hardware Controller";
    }
  }

  UpdateUI(s: SessionContext) {
    this.employee = s.Employee;
    this.branch = this.defaultData.defData.GetBranchFromId(s.BranchId);
    this.showNavBar = (s.EmployeeId > 0);
    this.terminalName = s.TerminalName;

    // Only show branch selection if customer has more than 1 active branch
    if (this.branches.length == 1)
      this.showBranchSelection = false;
    else {
      // if Employee is admin user then show Branch selection
      if (s.Employee != null)
        // Only show branch selection when admin user
        this.showBranchSelection = s.Employee.IsAdmin;
      else {
        // if employee is general user then do not show branch selection, except if no HWC Dongle found
        this.showBranchSelection = true;
      }
    }
  }

  getHWCUrl() {
    return this.HWCUrl;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.defaultDataSub) this.defaultDataSub.unsubscribe();
    if (this.sessionSub) this.sessionSub.unsubscribe();
    if (this.routerSub) this.routerSub.unsubscribe();
    if (this.branchChangedSub) this.branchChangedSub.unsubscribe();
    if (this.terminalSub) this.terminalSub.unsubscribe();
    if (this.HWCSub) this.HWCSub.unsubscribe();
    if (this.userLogin$) this.userLogin$.unsubscribe();
    if (this.userLogOut$) this.userLogOut$.unsubscribe();
    if (this.userUpdated$) this.userUpdated$.unsubscribe();
    if (this.HWCSub2) this.HWCSub2.unsubscribe();
    if (this.HWCSub3) this.HWCSub3.unsubscribe();
    if (this.onHWCConnected$) this.onHWCConnected$.unsubscribe();
  }

  toggleSidebarOpened(key) {
    this.sidebarService.getSidebar(key).toggleOpen();
  }

  SwitchUser() {
    // Checkout employee and show Login Dashboard.
    this.session.selectEmployee(-1, "").subscribe(r => {
      this.router.navigate([r.Msg]);
    });
  }

  returnToSysDashboard() {
    // We need to use this method of navigation here so that we do not route to the SPA's default route as '/SysDashboard' will not be found in the Angular Routes.
    window.location.href = '/SysDashboard';
  }

  showUserProfile() {
    //Show Employee Profile Dlg to allow them to change name, password or PIN
    this.employeeProfile.popupVisible = true;
  }

  selectBranch(branchId: number): void {
    // Save select branch in session config
    this.session.selectBranch(branchId);
  }

  resetHWC() {
    this.events.RebootHWCDevice(this.session.ctx.HWCInfo.BranchUId);
  }

  HWCDashboard() {
    window.open(this.getHWCUrl(), "_self");    
  }

  setLicenceExpiry(licenceExpiry: Date) {
    this.licenceExpiry = licenceExpiry;
    this.licenceExpiresWithin10Days = dayjs().add(11, 'day').isAfter(licenceExpiry, 'day');
  }
}
